<template>
    <ul class="list-group list-group-flush" id="locationList">
        <li class="list-group-item py-2" v-for="loc in locations" v-bind:data-id="loc.id" v-bind:class="{ active: loc.id == selected }" v-on:click="onClick" v-bind:key="loc.id">
            <i class="fa" v-bind:class="locationIconClass(loc.locationType)"></i>&nbsp;
            {{ loc.name }}
        </li>
    </ul>
</template>

<script>
export default {
    name:"LocationList",
    props: ['locations'],
	data: function() {
		return {
			selected: -1
		}
	},
	methods: {
		locationIconClass: function(locationType) {
			switch(locationType)
			{
			case 1:
			case 2:
				return 'fa-plane';
			case 3:
				return 'fa-train';
			case 4:
				return 'fa-building-o';
			default:
				return 'fa-building-o';
			}
		},

		select: function(id) {
			this.selected = id;
		},

		onClick: function(ev) {
			this.selected = parseInt(ev.target.getAttribute('data-id'));
			this.$emit('select', this.selected);
		}
	}
};
</script>

<style lang="scss" scoped></style>
